import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getBuildingsInventory,
  createBuilding,
  updateBuilding,
  deleteBuilding,
} from "../../../../../apis/Business/InventoryApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import InventoryBuildingTable from "./Table";
import SystemBoundary from "../../components/HeaderBox/SystemBoundary";
import SubHeaderBox from "../../components/SubHeaderBox";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryBuildingIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_building_icon.svg";
const InventoryBuilding = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [systemBoundaryCustom, setSystemBoundaryCustom] = useState();
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-inventory-building";
  const deleteKey = "delete-inventory-building";

  useEffect(() => {
    getBuildingsInventory({
      businessId: businessId,
      setBuildings: setCustomSubcategories,
    });
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryCustom,
      subcategory: "buildings",
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateBuilding(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createBuilding(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getBuildingsInventory({
          businessId: businessId,
          setBuildings: setCustomSubcategories,
        });

        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteBuilding(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("INV_BUILDINGS")}
            subDescription={t("INV_BUILDINGS_DESC")}
            isNormal={true}
            number={"5.1.3"}
            icon={inventoryBuildingIcon}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryCustom,
              setSystemBoundary: setSystemBoundaryCustom,
              totalObjCategory: "buildings",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
            showSystemBoundary={true}
          />
        </div>

        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          noDesc
          customStyles={{ marginLeft: "50px" }}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createBuilding}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  noDesc
                  customStyles={{ marginLeft: "50px" }}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />

                {showTable === sub.id && (
                  <InventoryBuildingTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InventoryBuilding;
